var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3039 8.97274L14.7882 12.0063L15.8593 16.5431C15.9184 16.7893 15.9032 17.0476 15.8156 17.2852C15.728 17.5229 15.5719 17.7292 15.3671 17.8782C15.1623 18.0271 14.9179 18.1121 14.6648 18.1222C14.4118 18.1324 14.1614 18.0673 13.9453 17.9352L9.99995 15.5071L6.0523 17.9352C5.83622 18.0666 5.58613 18.131 5.3335 18.1205C5.08087 18.11 4.837 18.0249 4.63261 17.8761C4.42822 17.7272 4.27243 17.5212 4.18488 17.284C4.09732 17.0468 4.08191 16.789 4.14058 16.5431L5.21558 12.0063L1.69995 8.97274C1.50878 8.80752 1.37052 8.58963 1.30244 8.34629C1.23436 8.10296 1.23947 7.84496 1.31715 7.60451C1.39483 7.36407 1.54162 7.15184 1.73919 6.99432C1.93677 6.83681 2.17637 6.74099 2.42808 6.71884L7.03745 6.34696L8.81558 2.04384C8.91182 1.80932 9.07563 1.60872 9.28618 1.46754C9.49673 1.32636 9.7445 1.25098 9.998 1.25098C10.2515 1.25098 10.4993 1.32636 10.7098 1.46754C10.9204 1.60872 11.0842 1.80932 11.1804 2.04384L12.9578 6.34696L17.5671 6.71884C17.8193 6.74017 18.0596 6.83545 18.2579 6.99275C18.4562 7.15004 18.6037 7.36236 18.6819 7.6031C18.76 7.84383 18.7654 8.10228 18.6973 8.34606C18.6292 8.58984 18.4907 8.80811 18.2992 8.97352L18.3039 8.97274Z",
    fill: "#343330"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Star.013e1fc8.svg";
export { ForwardRef as ReactComponent };